import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import { Journeys } from '@odp/journeys-sdk';

export type JourneysApi = Omit<
  Journeys<unknown>,
  'instance' | 'request' | 'setSecurityData'
>;

export const journeysApiRef: ApiRef<JourneysApi> = createApiRef<JourneysApi>({
  id: 'plugin.journeys.api',
});
